var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPatientInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1833 3.19993L13.6889 5.70549C13.7944 5.81105 13.7944 5.98327 13.6889 6.08882L7.62222 12.1555L5.04444 12.4416C4.7 12.4805 4.40833 12.1888 4.44722 11.8444L4.73333 9.2666L10.8 3.19993C10.9056 3.09438 11.0778 3.09438 11.1833 3.19993ZM15.6833 2.56382L14.3278 1.20827C13.9056 0.786046 13.2194 0.786046 12.7944 1.20827L11.8111 2.1916C11.7056 2.29716 11.7056 2.46938 11.8111 2.57493L14.3167 5.08049C14.4222 5.18605 14.5944 5.18605 14.7 5.08049L15.6833 4.09716C16.1056 3.67216 16.1056 2.98605 15.6833 2.56382ZM10.6667 10.5055V13.3333H1.77778V4.44438H8.16111C8.25 4.44438 8.33333 4.40827 8.39722 4.34716L9.50833 3.23605C9.71944 3.02494 9.56944 2.6666 9.27222 2.6666H1.33333C0.597222 2.6666 0 3.26382 0 3.99993V13.7777C0 14.5138 0.597222 15.111 1.33333 15.111H11.1111C11.8472 15.111 12.4444 14.5138 12.4444 13.7777V9.39438C12.4444 9.09716 12.0861 8.94993 11.875 9.15827L10.7639 10.2694C10.7028 10.3333 10.6667 10.4166 10.6667 10.5055Z",
    fill: "#0C6564"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPatientInfo);
export default __webpack_public_path__ + "static/media/EditPatientInfo.2cd2b763d178b905d22c2efee9591920.svg";
export { ForwardRef as ReactComponent };